import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Stethoscope } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/signin");
      return;
    }
    (async () => {
      try {
        await exchangeSession(sessionId);
        // Clear the fragment
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard");
      } catch (e) {
        setError("Could not complete Google sign-in. Please try again.");
        setTimeout(() => navigate("/signin"), 2000);
      }
    })();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-neu-bg gap-4">
      <div className="w-16 h-16 rounded-2xl neu-card flex items-center justify-center">
        <Stethoscope className="w-8 h-8 text-neu-accent" />
      </div>
      <p className="heading text-lg" data-testid="auth-callback-status">
        {error || "Completing sign-in…"}
      </p>
    </div>
  );
}
